import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Next } from '../models';

export const nextActions = createActionGroup({
    events: {
        'Get Next Content': emptyProps(),
        'Get Next Content Success': props<{ payload: Next }>(),
        'Get Next Content Error': emptyProps(),

        Clear: emptyProps(),
    },
    source: 'Content Next',
});
